import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { MainLayout } from 'src/layouts';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';

import styles from './PrivateRoutes.module.scss';

import Unauthuser from 'src/components/Error/Unauthuser';
import { AlertsToast } from 'src/components/Atoms/AlertsToast/AlertsToast';
import { baseApiCall } from 'src/api/Api';
import { dashboard_alerts } from 'src/constants/url';
import { hasEditAccess } from 'src/authorization/authorizationsConstants';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { alertsCount } from 'src/redux/features';
import { Loader } from 'src/components';
import { commonVaribles } from 'src/constants/constVariables';

export const PrivateRoutes = () => {
	const { isAuthenticated, user, route_privilege, isloader } =
		useAuthorizationContext();
	const [loader, setLoader] = useState(true);
	const [alertsData, setAlertsData] = useState([]);
	const dispatch = useDispatch();
	const location = useLocation();

	const selectedOption = useSelector((state) => state.allPlants?.plantName);
	const defaultValue = useSelector((state) => state.allPlants.plants);

	var check = user?.user_role?.some((role) =>
		route_privilege[role]?.includes(location?.pathname)
	);

	const timeintervalforNotification = useSelector(
		(state) => state?.user.timeTnterval?.notification_time_interval
	);

	useEffect(() => {
		setLoader(isloader);
	}, [isloader]);

	useEffect(() => {
		if (hasEditAccess(user, 'alerts')) {
			fetchLetestAlertList();
		}
	}, [user, selectedOption, defaultValue[0]]);

	useEffect(() => {
		if (hasEditAccess(user, 'alerts')) {
			const fetchSequencingReportListInterval = setInterval(() => {
				fetchLetestAlertList();
			}, timeintervalforNotification);
			return () => {
				clearInterval(fetchSequencingReportListInterval);
			};
		}
	}, [timeintervalforNotification, user, selectedOption, defaultValue[0]]);

	const LoadingFunction = () => {
		return !loader ? (
			<div className={styles.unauthorizedError}>
				<Unauthuser />
			</div>
		) : (
			<div className={styles['loader']}>
				<Loader />
			</div>
		);
	};

	const fetchLetestAlertList = () => {
		baseApiCall({
			url: dashboard_alerts.GET_ALERTS_LIST_FOR_NOTIFICATION,
			requestBody: {},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res && res.data && res.data.result && res.data.result !== '') {
					const data = res.data.result.data;
					const count = res.data.result.count;
					setAlertsData(data);
					dispatch(alertsCount(count));
				}
			},
			onFailure: (res) => {},
			errorCall: (res) => {},
		});
	};

	return isAuthenticated && check ? (
		<MainLayout>
			<Outlet />
			<AlertsToast notifications={alertsData} />
		</MainLayout>
	) : (
		<LoadingFunction />
	);
};
